import './CapabilitiesSection.css'

const caps = [
  { icon: '🖥️', title: 'Sistemas Web', desc: 'Plataformas robustas, escaláveis e seguras com tecnologias modernas.' },
  { icon: '📱', title: 'Apps Mobile', desc: 'Aplicativos nativos e híbridos focados na experiência do usuário.' },
  { icon: '🧭', title: 'Consultoria em TI', desc: 'Diagnóstico, estratégia e planejamento para acelerar a transformação digital.' },
  { icon: '📈', title: 'BI e Indicadores', desc: 'Painéis de gestão, dashboards executivos e análises que apoiam decisões.' },
  { icon: '🔒', title: 'Conformidade', desc: 'Soluções aderentes à LGPD, transparência ativa e boas práticas.' },
  { icon: '🔗', title: 'Integrações', desc: 'Conexão fluida com sistemas legados, APIs públicas e terceiros.' },
]

export default function CapabilitiesSection() {
  return (
    <section className="section" style={{ background: 'var(--bg-2)' }}>
      <div className="section-inner">
        <div className="section-eyebrow">O que entregamos</div>
        <h2 className="section-title">Capacidades técnicas que viram resultado</h2>
        <div className="capabilities-grid" style={{ marginTop: 48 }}>
          {caps.map((c, i) => (
            <div className="cap-card" key={i}>
              <div className="cap-icon">{c.icon}</div>
              <h4>{c.title}</h4>
              <p>{c.desc}</p>
              <span className="cap-link">Saiba mais →</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
